/**
 * Created by Carsten Bühler
 * User: CBuehler on 12.02.2016
 * Copyright: xdot GmbH 2015
 */

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { AmdRequireComponent } from 'plugin/liferay-widgets-react-web';

const JournalListItem = ({ item }) => {
    const journalEntry = item;

    let journalMessage = undefined;
    try {
        journalMessage = journalEntry.message && JSON.parse(journalEntry.message);
    } catch (e) {
        console.error('Error parsing journal.message', journalMessage);
    }

    return (
        <AmdRequireComponent dependencies={['JournalRenderer/' + journalEntry.type]}>
            {
                (Renderer) => <Renderer message={journalMessage} entry={journalEntry}/>
            }
        </AmdRequireComponent>);
};

JournalListItem.propTypes = {
    item: PropTypes.object
};

export default JournalListItem;



// WEBPACK FOOTER //
// ./js/components/JournalListItem.jsx